export default __webpack_public_path__ + "static/media/om.a960d07f.svg";